// extracted by mini-css-extract-plugin
export var blockedMessage = "_bs-3";
export var blockedOverlay = "_bs-1";
export var fadeIn = "_bs-2";
export var hereLink = "_bs-0";
export var slideUp = "_bs-4";